import { AlertService } from '@/services/alert.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { PropertiesService, RealProperty, RealPropertyCreate } from '@eemo/api-client';
import { Subscription } from 'rxjs';
import { AddressData } from '../../models/AddressData';
import { PropertyAddAddressComponent } from '../property-add-address/property-add-address.component';
import { NgTemplateOutlet } from '@angular/common';
import { ModalBaseComponent } from '../base/modal-base/modal-base.component';
export class PropertyAddSimpleDialogData {
  parent?: RealProperty;
  withAddressSearch = true;
}

@Component({
    selector: 'app-property-add-simple-dialog',
    templateUrl: './property-add-simple-dialog.component.html',
    styleUrls: ['./property-add-simple-dialog.component.scss'],
    standalone: true,
    imports: [ModalBaseComponent, NgTemplateOutlet, MatDialogModule, PropertyAddAddressComponent]
})
export class PropertyAddSimpleDialogComponent implements OnInit, OnDestroy {
  @ViewChild(PropertyAddAddressComponent) addAddress: PropertyAddAddressComponent;
  propertyAddForm: UntypedFormGroup;

  dialogTitle = 'Créer un nouveau bien';

  selectedAddress: AddressData;
  public searchAddressResults: AddressData[];

  sub = new Subscription();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PropertyAddSimpleDialogData,
    private propertiesService: PropertiesService,
    private alertService: AlertService,
    public dialogRef: MatDialogRef<PropertyAddSimpleDialogComponent>
  ) {}
  ngOnInit(): void {}

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  get formSubmitting() {
    return this.addAddress ? this.addAddress.formSubmitting : false;
  }
  get formInvalid() {
    return this.addAddress ? this.addAddress.form.invalid : true;
  }

  onSubmit() {
    this.addAddress.onSubmit();
  }

  onPropertyCreated(propertyCreate: RealPropertyCreate) {
    this.sub = this.propertiesService.createRealProperty(propertyCreate).subscribe({
      next: (createdId) => {
        this.dialogRef.close(createdId);
        this.alertService.success('Création du bien effectuée');
      },
      error: (err: HttpErrorResponse) => {
        this.dialogRef.close(false);
      }
    });
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }
}
